var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manage-accounts-row flex row" }, [
    _c("div", { staticClass: "logo" }, [
      _vm.account.logo
        ? _c("img", { attrs: { src: _vm.logo, alt: "Account Logo" } })
        : _c("div", [
            _c("i", { staticClass: "material-icons" }, [_vm._v("business")]),
          ]),
    ]),
    _c("div", { staticClass: "details flex column" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v(" " + _vm._s(_vm.account.name) + " "),
      ]),
      _c(
        "div",
        { staticClass: "top flex", class: { unassigned: !_vm.primary } },
        [
          _vm.primary
            ? [
                _c("div", { staticClass: "companies" }, [
                  _vm._v(" Assigned To "),
                  _c("b", [_vm._v(" " + _vm._s(_vm.primary.fullName) + " ")]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm.contact
        ? _c("div", { staticClass: "contact flex" }, [
            _c("div", [_vm._v(_vm._s(_vm.contact.emailAddress))]),
            _vm.contact.emailAddress && _vm.contact.phone
              ? _c("span", { staticClass: "dot" }, [_vm._v(" · ")])
              : _vm._e(),
            _c("div", [_vm._v(_vm._s(_vm.contact.phone))]),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "actions flex row" },
      [
        _vm.currentUserIsAdmin || _vm.isAssignedToCurrentUser
          ? [
              _c(
                "dropdown-actions",
                {
                  staticClass: "light",
                  attrs: { items: _vm.actions, value: {} },
                  on: { input: _vm.executeAction },
                },
                [
                  _c("template", { slot: "value" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("settings"),
                    ]),
                    _vm._v(" Manage "),
                  ]),
                ],
                2
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }